import { GraphQLInputObjectType, GraphQLString } from 'graphql'

export interface LibraryUsageFilterArg {
  readonly filterText?: string
}

export const libraryUsageFilterArgType = new GraphQLInputObjectType({
  name: 'LibraryUsageFilterArg',
  description:
    'A collection of criteria categories and values to filter the library usage items by. Each criteria category consists of a list of strings. Categories of criteria are applied with an AND relationship. Within each category, the individual criteria values are applied with an OR relationaship',
  fields: () => ({
    filterText: {
      description:
        'Filter library usage items whose names match the specified text string',
      type: GraphQLString
    }
  })
})
